/* todocompra — extras de página de producto (prefijo tcp-) */
(function () {
  if (window.__tcpPlus) return; window.__tcpPlus = true;
  document.documentElement.classList.add('tcp-js');
  function fmt(centavos) {
    var n = Math.round(Number(centavos) / 100);
    return '$' + String(n).replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  }

  /* ---- Packs por cantidad ---- */
  function initPacks() {
    var cont = document.querySelector('[data-tcp-packs]');
    if (!cont) return;
    var form = cont.closest('form') || document.querySelector('form[data-tc-producto-form]');
    var input = form && form.querySelector('[data-tc-cantidad-input]');
    var packs = Array.prototype.slice.call(cont.querySelectorAll('[data-tcp-pack]'));
    var base = Number(cont.getAttribute('data-precio')) || 0;

    function pintarPrecios() {
      packs.forEach(function (p) {
        var q = Number(p.getAttribute('data-cantidad'));
        var d = Number(p.getAttribute('data-dto')) || 0;
        var total = base * q * (100 - d) / 100;
        var b = p.querySelector('[data-tcp-pack-precio]');
        var s = p.querySelector('[data-tcp-pack-tachado]');
        if (b) b.textContent = fmt(total);
        if (s && d > 0) s.textContent = fmt(base * q);
        var a = p.querySelector('[data-tcp-pack-ahorro]');
        if (a && d > 0) a.textContent = fmt(base * q - total);
      });
    }
    function marcar(q) {
      packs.forEach(function (p) {
        var on = Number(p.getAttribute('data-cantidad')) === q;
        p.classList.toggle('is-activo', on);
        p.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
    }
    packs.forEach(function (p) {
      p.addEventListener('click', function () {
        var q = Number(p.getAttribute('data-cantidad'));
        if (input) { input.value = q; input.dispatchEvent(new Event('input', { bubbles: true })); input.dispatchEvent(new Event('change', { bubbles: true })); }
        marcar(q);
      });
    });
    if (input) {
      var sync = function () { marcar(Number(input.value)); };
      input.addEventListener('input', sync);
      input.addEventListener('change', sync);
      form.querySelectorAll('[data-tc-cantidad]').forEach(function (b) { b.addEventListener('click', function () { setTimeout(sync, 0); }); });
      sync();
    }
    /* Si cambia la variante, recalcula con el nuevo precio */
    var precio = document.querySelector('[data-tc-precio]');
    var variantes = document.querySelector('[data-tc-variantes-json]');
    if (precio && variantes) {
      var lista = []; try { lista = JSON.parse(variantes.textContent); } catch (e) {}
      new MutationObserver(function () {
        var txt = precio.textContent.trim();
        var v = lista.filter(function (x) { return x.price_fmt === txt; })[0];
        if (v) { base = Number(v.price); pintarPrecios(); }
      }).observe(precio, { childList: true, characterData: true, subtree: true });
    }
    pintarPrecios();
  }

  /* ---- Barra pegajosa ---- */
  function initSticky() {
    var barra = document.querySelector('[data-tcp-sticky]');
    var objetivo = document.querySelector('form[data-tc-producto-form] .tc-pdp__comprar--mercadopago') || document.querySelector('form[data-tc-producto-form]');
    if (!barra || !objetivo || barra.__tcpListo) return;
    barra.__tcpListo = true;
    var precioBarra = barra.querySelector('[data-tcp-sticky-precio]');
    var precio = document.querySelector('[data-tc-precio]');
    function copiarPrecio() { if (precioBarra && precio) precioBarra.textContent = precio.textContent; }
    if (precio) { copiarPrecio(); new MutationObserver(copiarPrecio).observe(precio, { childList: true, characterData: true, subtree: true }); }
    var pendiente = false;
    function revisar() {
      pendiente = false;
      var r = objetivo.getBoundingClientRect();
      var pasado = r.height > 0 && r.bottom < 0;
      barra.classList.toggle('is-visible', pasado); document.body.classList.toggle('tcp-sticky-on', pasado);
      barra.setAttribute('aria-hidden', pasado ? 'false' : 'true');
    }
    function pedir() { if (!pendiente) { pendiente = true; requestAnimationFrame(revisar); } }
    window.addEventListener('scroll', pedir, { passive: true });
    window.addEventListener('resize', pedir);
    revisar();
    var ir = barra.querySelector('[data-tcp-sticky-ir]');
    if (ir) ir.addEventListener('click', function () {
      var f = document.querySelector('form[data-tc-producto-form]');
      if (f) f.scrollIntoView({ behavior: 'smooth', block: 'center' });
    });
  }

  /* ---- Upsell: agregar al carrito sin salir ---- */
  function initUpsell() {
    document.querySelectorAll('[data-tcp-up-agregar]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var id = btn.getAttribute('data-variante');
        if (!id || btn.disabled) return;
        var original = btn.textContent;
        btn.disabled = true; btn.textContent = '...';
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] })
        }).then(function (r) { if (!r.ok) throw new Error('x'); return r.json(); })
          .then(function () {
            btn.classList.add('is-ok'); btn.textContent = btn.getAttribute('data-texto-ok') || 'Agregado';
            document.dispatchEvent(new CustomEvent('tcp:cart-updated'));
            fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) {
              document.querySelectorAll('.cart-count-bubble span:first-child, [data-cart-count]').forEach(function (el) { el.textContent = c.item_count; });
            }).catch(function () {});
          })
          .catch(function () { btn.disabled = false; btn.textContent = original; });
      });
    });
  }


  /* ---- Carrito lateral: agregar sin salir de la página ---- */
  function agregarYMostrar(id, cantidad, boton) {
    var cart = document.querySelector('cart-drawer');
    if (!cart || typeof cart.renderContents !== 'function') return false;
    var cuerpo = {
      items: [{ id: Number(id), quantity: Number(cantidad) || 1 }],
      sections: cart.getSectionsToRender().map(function (s) { return s.id; }).join(','),
      sections_url: window.location.pathname
    };
    if (boton) boton.disabled = true;
    fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(cuerpo) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
      .then(function (j) { cart.renderContents(j); })
      .catch(function () { window.location.href = '/cart'; })
      .then(function () { if (boton) boton.disabled = false; });
    return true;
  }
  function initCarritoLateral() {
    if (window.__tcpCartLateral) return; window.__tcpCartLateral = true;
    document.addEventListener('click', function (e) {
      var up = e.target.closest && e.target.closest('[data-tcp-cart-add]');
      if (up) { e.preventDefault(); agregarYMostrar(up.getAttribute('data-variante'), 1, up); return; }
      var btn = e.target.closest && e.target.closest('.tc-pdp__carrito');
      if (btn && document.querySelector('cart-drawer')) {
        var form = btn.closest('form'); if (!form) return;
        var id = form.querySelector('input[name="id"]'); var q = form.querySelector('input[name="quantity"]');
        if (!id || btn.disabled) return;
        if (agregarYMostrar(id.value, q ? q.value : 1, btn)) e.preventDefault();
      }
    });
  }
  /* ---- Aparición suave ---- */
  function initReveal() {
    var els = document.querySelectorAll('.tcp-rev');
    if (!els.length) return;
    if (!('IntersectionObserver' in window)) { els.forEach(function (e) { e.classList.add('is-in'); }); return; }
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
    }, { threshold: 0.12 });
    els.forEach(function (e) { io.observe(e); });
  }

  /* ---- Botón de pago contra entrega (Releasit): texto "Pedir con Pago contra entrega" ---- */
  function initTextoContraEntrega() {
    if (!document.querySelector('.tc-pdp, [data-tc-pdp]') || window.__tcpTextoCod) return;
    window.__tcpTextoCod = true;
    var TEXTO = 'Pedir y Pagar al Recibir';
    var SUBTITULO = 'Pagas en efectivo o tarjeta cuando llegue tu paquete';
    function aplicar() {
      document.querySelectorAll('[id="rsi_buy_now_button"]').forEach(function (b) {
        var walker = document.createTreeWalker(b, NodeFilter.SHOW_TEXT, null);
        var n;
        while ((n = walker.nextNode())) {
          var t = n.nodeValue.trim();
          if (!t) continue;
          if (t !== TEXTO && /^(pedir con )?pago contra entrega$/i.test(t)) n.nodeValue = TEXTO;
          else if (t !== SUBTITULO && /^pagas al recibir tu compra$/i.test(t)) n.nodeValue = SUBTITULO;
        }
      });
    }
    aplicar();
    new MutationObserver(aplicar).observe(document.body, { childList: true, subtree: true, characterData: true });
  }

  /* ---- Popup informativo de envíos ---- */
  function initPopupEnvio() {
    var cont = document.querySelector('[data-tcp-popup-envio]');
    if (!cont || cont.__tcpListo) return;
    cont.__tcpListo = true;
    document.body.appendChild(cont);
    var clave = 'tcpPopEnvioMin', minimizado = false;
    try { minimizado = sessionStorage.getItem(clave) === '1'; } catch (e) {}
    function mostrar(abierto) {
      cont.classList.toggle('is-abierto', abierto);
      cont.classList.toggle('is-minimizado', !abierto);
    }
    function guardar(v) { try { sessionStorage.setItem(clave, v ? '1' : '0'); } catch (e) {} }
    cont.hidden = false;
    var x = cont.querySelector('[data-tcp-popenv-cerrar]'); if (x) x.addEventListener('click', function () { mostrar(false); guardar(true); });
    var ab = cont.querySelector('[data-tcp-popenv-abrir]'); if (ab) ab.addEventListener('click', function () { mostrar(true); guardar(false); });
    if (minimizado) mostrar(false); else setTimeout(function () { mostrar(true); }, 2500);
  }
  function arrancar() { initPacks(); initSticky(); initUpsell(); initReveal(); initCarritoLateral(); initTextoContraEntrega(); initPopupEnvio(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', arrancar); else arrancar();
  document.addEventListener('shopify:section:load', arrancar);
})();
